import styled from 'styled-components'
import {
  widthResize,
  widthFull,
  heightHeader,
  surface,
  brandDark,
  boxShadow,
  borderSoft,
  muted,
} from '../Resources/Theme'

const Header = styled.header`
  position: fixed;
  height: ${heightHeader};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  left: ${props => props.resize ? widthResize : widthFull};
  box-shadow: ${boxShadow};
  background: ${surface};
  border-bottom: 1px solid ${borderSoft};
  transition: .35s ease;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 4;
  
  @media (max-width: 992px) {
    left: 0;
    width: 100%;
    grid-template-columns: 1fr 1fr 1fr;
    background: ${brandDark};
    border-bottom: none;
  }
`

Header.Left = styled.div`
  height: ${heightHeader};
  display: none;
  text-align: center;
  color: ${brandDark};

  @media (max-width: 992px) {
    width: 33%;
    display: flex;
    color: #fff;
  }
`

Header.Brand = styled.div`
  display: none;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    align-self: center;
    justify-content: center;
    display: flex;
  }
`

Header.Brand.Logo = styled.img`
  @media (max-width: 992px) {
    max-height: 40px;
  }
`

Header.Right = styled.div`
  height: ${heightHeader};
  display: flex;
  justify-content: flex-end;
  max-height: ${heightHeader};
  align-items: center;

  @media (max-width: 992px) {
    width: 100%;
  }
`

Header.Right.Icon = styled.div`
  height: ${heightHeader};
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  color: ${muted};
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: rgba(40, 104, 64, 0.08);
    color: ${brandDark};
  }

  @media (max-width: 992px) {
    width: 40px;
    color: #fff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.12);
      color: #fff;
    }
  }
`

Header.Right.Image = styled.img`
  border-radius: ${props => props.maxHeight ? props.maxHeight : '50%'};
  height: ${props => props.maxHeight ? props.maxHeight : '36px'};
  width: ${props => props.maxHeight ? props.maxHeight : '36px'};
  box-shadow: ${boxShadow};
  object-fit: cover;
  border: 2px solid ${borderSoft};
`

export default Header
